/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

import HeaderMenuMobile from './scripts/header-menu-mobile';
import InView from './scripts/in-view';
import PageStatus from './scripts/page-status';

const scripts = [PageStatus, HeaderMenuMobile, InView];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }
});

// Vendors
// import './vendors/';
